module.exports = __webpack_public_path__ + "static/media/sopt12kz.f6571bf4.pdf";